import type { Hierarchy } from "@/api/flash.service";

export type ViewType = "lojas" | "cats" | "visao" | "diario";
export type SortKey = "nome" | "atual" | "meta" | "ant" | "ano" | "difMeta" | "difAnt" | "difAno";

export interface TableRow {
  key: string;
  nome: string;
  atual: number;
  meta: number;
  ant: number;
  ano: number;
  difMeta: number;
  difAnt: number;
  difAno: number;
}

export interface CatFlatRow {
  item: Hierarchy;
  key: string;
  depth: number;
  isExpanded: boolean;
  isLoadingChildren: boolean;
  canExpand: boolean;
  parentCatCode: string | null;
}

export interface DiarioEntry {
  label: string;
  isToday: boolean;
  byLoja: Record<string, { atual: number; meta: number; difAbsoluto: number; dif: number; pctAtingMes: number; vendaAcumulada: number }>;
}

export const VIEW_TABS: { key: ViewType; label: string }[] = [
  { key: "lojas", label: "Por Loja" },
  { key: "cats", label: "Por Categoria" },
  { key: "visao", label: "Visão" },
  { key: "diario", label: "Diário" },
];
